import { useContext, useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Formik, Form, FieldArray } from "formik";
import ReactQuill from "react-quill-new";
import "react-quill-new/dist/quill.snow.css";
import CustomSelect from "../../components/CustomSelect";
import ComponentInput from "../../components/componentInput";
import { UserContext } from "../../contexts/UserContext";
import { GetAllTypes, GetBlogByIdAPI, UpdateBlogAPI } from "../../helpers/api";
import AddImage from "../../assets/icons/iconAddImage.svg";
import IconAdd from '../../assets/icons/iconAdd.svg'
const modules = {
  toolbar: [
    [{ header: [1, 2, 3, false] }],
    ["bold", "italic", "underline", "strike"],
    [{ color: [] }, { background: [] }],
    [{ list: "ordered" }, { list: "bullet" }],
    ["link"],
    ["clean"],
  ],
};

const formats = [
  "header",
  "bold",
  "italic",
  "underline",
  "strike",
  "color",
  "background",
  "list",
  "link",
];
 
const DetailArticle = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { user } = useContext(UserContext);
  const [ListeCategorie, setListeCategorie] = useState([]);

  const [imageError, setImageError] = useState(false);
  const [contentImageErrors, setContentImageErrors] = useState({});
  const [titleFAQ, setTitleFAQ] = useState("");
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const [initialValues, setInitialValues] = useState({
    type: "",
    slug: "",
    blogTitle: "",
    shortDescription: "",
    tags: "",
    auteur: "",
    metadata: { title: "", description: "" },
    published: true,
    articlePrefer: false,
    articleCategoriePrefer: false,
    mainImageFile: null,
    mainImagePreview: null,
    contentBlocks: [
      { titleContent: "", paragraphe: "", file: null, imagePreviewUrl: "" },
    ],
    faq: [{ title: "", paragraphe: "" }],
  });

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await GetAllTypes();

        if (response?.success) {
          const formattedData = response?.data?.map((item) => {
            const capitalized = item?.charAt(0)?.toUpperCase() + item?.slice(1);
            return {
              value: item,
              label: capitalized,
            };
          });
          setListeCategorie(formattedData);
        }
      } catch (error) {
        console.error("Error fetching blogs:", error);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    const fetchArticleData = async () => {
      setLoading(true);
      try {
        const response = await GetBlogByIdAPI(id, user?.accessToken);

        if (response?.success && response?.data) {
          const blog = response.data;

          if (blog.faq && blog.faq.length > 0) {
            setTitleFAQ(blog.faq[0].faqTitle || "");
          }

          setInitialValues({
            type: blog.type || "",
            slug: blog.slug || "",
            blogTitle: blog.blogTitle || "",
            shortDescription: blog.shortDescription || "",
            tags: blog.tags || "",
            auteur: blog.auteur || "",
            metadata: blog.metadata || { title: "", description: "" },
            published: blog.published !== undefined ? blog.published : true,
            articlePrefer: blog.articlePrefer || false,
            articleCategoriePrefer: blog.articleCategoriePrefer || false,
            mainImageFile: null,
            mainImagePreview: blog.image || null,
            contentBlocks: blog.content?.map((block) => ({
              titleContent: block.titleContent || "",
              paragraphe: block.paragraphe || "",
              file: null,
              imagePreviewUrl: block.image || "",
            })) || [
              {
                titleContent: "",
                paragraphe: "",
                file: null,
                imagePreviewUrl: "",
              },
            ],
            faq: blog.faq?.map((item) => ({
              title: item.title || "",
              paragraphe: item.paragraphe || "",
            })) || [{ titleContent: "", paragraphe: "" }],
          });
        }
      } catch (err) {
        console.error("Error loading article:", err);
        setError("Failed to fetch article details.");
      } finally {
        setLoading(false);
      }
    };

    if (id) {
      fetchArticleData();
    }
  }, [id, user?.accessToken]);

  const handleSubmitForm = async (values, { setSubmitting }) => {
    setError(null);
    const dataPayload = new FormData();

    dataPayload.append("type", values.type);
    dataPayload.append("slug", values.slug);
    dataPayload.append("blogTitle", values.blogTitle);
    dataPayload.append("shortDescription", values.shortDescription);
    dataPayload.append("tags", values.tags);
    dataPayload.append("auteur", values.auteur);
    dataPayload.append("published", values.published);
    dataPayload.append("articlePrefer", values.articlePrefer);
    dataPayload.append("articleCategoriePrefer", values.articleCategoriePrefer);
    dataPayload.append("metadata", JSON.stringify(values.metadata));

    const finalizedFaq = values.faq.map((item) => ({
      ...item,
      faqTitle: titleFAQ,
    }));
    dataPayload.append("faq", JSON.stringify(finalizedFaq));

    if (values.mainImageFile) {
      dataPayload.append("image", values.mainImageFile);
    }

    let imageCounter = 1;
    const contentBlocksWithKeys = values.contentBlocks.map((block) => {
      let currentKey = "";

      if (block.file) {
        currentKey = `contentImage${imageCounter}`;
        dataPayload.append(currentKey, block.file);
        imageCounter++;
      } else if (block.imagePreviewUrl) {
        currentKey = block.imagePreviewUrl;
      }

      return {
        titleContent: block.titleContent,
        paragraphe: block.paragraphe,
        imageKey: currentKey,
      };
    });

    dataPayload.append("content", JSON.stringify(contentBlocksWithKeys));

    for (let pair of dataPayload.entries()) {
      console.log(pair[0] + "trt: ", pair[1]);
    }

    try {
      const response = await UpdateBlogAPI(id, dataPayload);
      if (response?.success) {
        alert("Article updated successfully!");
        navigate("/super-agent-list-blogs");
    
      }
    } catch (err) {
      setError(err.message || "An error occurred while saving updates.");
    } finally {
      setSubmitting(false);
    }

    
  };

 const IMAGE_DIMENSIONS = {
  header: {
    minWidth: 1200,
    minHeight: 600,
  },
  content: {
    maxWidth: 800,
    maxHeight: 600,
  },
};

const validateImageDimensions = (file, imageType) => {
  return new Promise((resolve, reject) => {
    const image = new Image();
    const objectUrl = URL.createObjectURL(file);

    image.onload = () => {
      const { naturalWidth, naturalHeight } = image;

      let isValid = false;

      if (imageType === "header") {
        const { minWidth, minHeight } = IMAGE_DIMENSIONS.header;

        isValid =
          naturalWidth >= minWidth &&
          naturalHeight >= minHeight;
      }

      if (imageType === "content") {
        const { maxWidth, maxHeight } = IMAGE_DIMENSIONS.content;

        isValid =
          naturalWidth <= maxWidth &&
          naturalHeight <= maxHeight;
      }

      if (isValid) {
        resolve(objectUrl);
      } else {
        URL.revokeObjectURL(objectUrl);

        reject(
          new Error(
            `Invalid dimensions: ${naturalWidth} × ${naturalHeight}px`
          )
        );
      }
    };

    image.onerror = () => {
      URL.revokeObjectURL(objectUrl);
      reject(new Error("Unable to read image"));
    };

    image.src = objectUrl;
  });
};

//    const validateImageDimensions = (file) => {
//   return new Promise((resolve, reject) => {
//     const img = new Image();
//     const objectUrl = URL.createObjectURL(file);

//     img.onload = () => {
//       const { naturalWidth, naturalHeight } = img;
//       if (naturalWidth >= REQUIRED_WIDTH && naturalHeight >= REQUIRED_HEIGHT) {
//         resolve(objectUrl); // on garde l'URL, elle sera utilisée pour la preview
//       } else {
//         URL.revokeObjectURL(objectUrl); // on ne garde pas cette URL, on la libère
//         reject(
//           `Dimensions invalides : Minimum ${REQUIRED_WIDTH} x ${REQUIRED_HEIGHT}px. `
//         );
//       }
//     };

//     img.onerror = () => {
//       URL.revokeObjectURL(objectUrl);
//       reject("Impossible de lire ce fichier comme image.");
//     };

//     img.src = objectUrl;
//   });
// };
 const slugify = (text) => {
  return text
    .toString()
    .normalize("NFD")                   // décompose les accents (é -> e + ́)
    .replace(/[\u0300-\u036f]/g, "")    // supprime les accents
    .toLowerCase()                       // tout en minuscule
    .trim()                              // supprime espaces début/fin
    .replace(/[^a-z0-9\s-]/g, "")        // supprime caractères spéciaux
    .replace(/\s+/g, "-")                // remplace espaces par -
    .replace(/-+/g, "-")                 // supprime tirets multiples
    // .replace(/^' '+|-+$/g, "");            // supprime tirets début/fin
};
  if (loading) {
    return (
      <div className="flex justify-center items-center min-h-[400px]">
        <p className="text-gray-500 font-medium text-lg animate-pulse">
          Loading article details...
        </p>
      </div>
    );
  }

  return (
    <div className="mx-auto w-full  p-6 bg-white rounded-lg shadow ">
      <div className="flex justify-between items-center mb-6 border-b pb-4">
        <h1 className="text-2xl font-bold text-gray-800">Edit Article</h1>
        <button
          onClick={() => navigate(-1)}
          className="text-sm font-medium text-gray-600 hover:text-gray-900 border px-3 py-1.5 rounded"
        >
          Back
        </button>
      </div>

      {error && <p className="text-red-500 mb-4">{error}</p>}

      <Formik
        initialValues={initialValues}
        onSubmit={handleSubmitForm}
        enableReinitialize
      >
        {({ values, handleChange, setFieldValue, isSubmitting }) => (
          <Form className="flex flex-col gap-8">

            <label
              className={`${
                values.mainImagePreview ? "bg-transparent" : "bg-[#F1F1FF]"
              } w-full relative rounded-[10px] min-h-[136px] flex items-center justify-center flex-col`}
            >
              {values.mainImagePreview && (
                <img
                  src={values.mainImagePreview}
                  alt="Preview"
                  className="h-[500px] w-full object-cover rounded mt-4"
                />
              )}
              <div className="absolute flex flex-col items-center space-y-2">
                <img
                  className=""
                  width={32}
                  height={32}
                  src={AddImage}
                  alt=""
                />
                {!values.mainImagePreview && (
                  <p className="text-[#808091] text-[10px]">
                    Add a cover picture <br />
                      (Minimum dimensions: {IMAGE_DIMENSIONS['header'].minWidth} × {IMAGE_DIMENSIONS['header'].minHeight} px)
                  </p>
                )}
              </div>
              
              <input
                type="file"
                accept="image/*"
                 onChange={ async(e)=>{
                  const file = e.target.files[0];
                  if (!file) return
                  setImageError(false)
                  try{
                    const validUrl = await validateImageDimensions(file, 'header');
                    setFieldValue("mainImageFile", file);
                    setFieldValue("mainImagePreview", validUrl);
                  }catch{
                    setImageError(true);
                    setFieldValue("mainImageFile", null);
                    setFieldValue("mainImagePreview", null);
                    e.target.value = ""; 

                  }

                }}
                className="hidden "
              />
              
            </label>
            {imageError && (
                <p className="text-red-500 text-[12px] mt-1">The image must be at least {IMAGE_DIMENSIONS['header'].minWidth} x {IMAGE_DIMENSIONS['header'].minHeight} pixels.</p>
              )}

            <div className="flex w-full gap-3 justify-between  items-center">
              <CustomSelect
              sizeTexte="w-full"
              label='Article Category'
              isRequired={true}
              id="type"
              options={ListeCategorie}
              value={
                ListeCategorie.find(
                  (cat) =>
                    cat.value.toLowerCase() ===
                    (values.type || "").toLowerCase()
                )?.type || values.type
              }
              placeholder="Select a Category"
              onChange={(val, id) => setFieldValue(id, val)}
              styleSlect="top-full"
            />

              <div className="flex w-full flex-wrap gap-6 items-center justify-between h-[42px] px-6 rounded-[8px] bg-[#F1F1FF]  border border-gray-100">
              <label className="flex items-center gap-2 cursor-pointer text-sm font-medium text-gray-700">
                <input
                  type="checkbox"
                  name="published"
                  checked={values.published}
                  onChange={(e) => setFieldValue("published", e.target.checked)}
                  className="w-4 h-4 rounded border-gray-300 text-blue-600 focus:ring-blue-500"
                />
                Published
              </label>

              <label className="flex items-center gap-2 cursor-pointer text-sm font-medium text-gray-700">
                <input
                  type="checkbox"
                  name="articlePrefer"
                  checked={values.articlePrefer}
                  onChange={(e) =>
                    setFieldValue("articlePrefer", e.target.checked)
                  }
                  className="w-4 h-4 rounded border-gray-300 text-blue-600 focus:ring-blue-500"
                />
                Featured Article
              </label>

              <label className="flex items-center gap-2 cursor-pointer text-sm font-medium text-gray-700">
                <input
                  type="checkbox"
                  name="articleCategoriePrefer"
                  checked={values.articleCategoriePrefer}
                  onChange={(e) =>
                    setFieldValue("articleCategoriePrefer", e.target.checked)
                  }
                  className="w-4 h-4 rounded border-gray-300 text-blue-600 focus:ring-blue-500"
                />
                Featured Category
              </label>
            </div>

            </div>
            

            <ComponentInput
              isRequired={true}
              placeholder="Metadata Title"
              label='Metadata Title'
              name="metadata.title"
              valueInput={values.metadata.title}
              onChange={handleChange}
              maxLength={60}
              minLength={30}
            />

            <ComponentInput
              label='Metadata Description'
              isRequired={true}
              placeholder="Metadata Description"
              name="metadata.description"
              valueInput={values.metadata.description}
              onChange={handleChange}
              maxLength={160}
              minLength={120}
            />
           

            <ComponentInput
              isRequired={true}
            label='Article Title'
              placeholder="Article Title"
              name="blogTitle"
              valueInput={values.blogTitle}
              onChange={handleChange}
              maxLength={70}
              minLength={10}
            />

            <ComponentInput
              typeInput="textarea"
              label='Short Description'
              placeholder="Short Description"
              name="shortDescription"
              valueInput={values.shortDescription}
              onChange={handleChange}
              maxLength={250}
              minLength={50}
            />

             <ComponentInput
              placeholder="Slug"
              label="Slug"
              name="slug"
              valueInput={values.title? values.title.replaceAll(' ', '_')  : values.slug}
               onChange={(e) => {
                  const slugValue = e.target.value;
                  // if (/^[A-Za-z_]*$/.test(slugValue)) {
                    setFieldValue("slug",slugify(slugValue));
                  // }
                }}
            />

            <ComponentInput
              label='Author'
              placeholder="Author"
              name="auteur"
              valueInput={values.auteur}
              onChange={handleChange}
            />

            {/* <ComponentInput
              label='Tags'
              placeholder="Tags"
              name="tags"
              valueInput={values.tags}
              onChange={handleChange}
            /> */}

            

            <FieldArray name="contentBlocks">
              {({ push, remove }) => (
                <div>
                 
                  {values.contentBlocks.map((block, index) => (
                    <div
                      key={index}
                      className="mt-6  bg-[#F1F1FF] rounded-[6px]  p-4  relative"
                    >
                      <div className="flex justify-between items-center mb-2">
                        <label className="text-[16px] text-[#5754E5] font-medium">
                          Content Block {index + 1}
                        </label>
                        {values.contentBlocks.length > 1 && (
                          <button
                            type="button"
                            onClick={() => remove(index)}
                            className="text-red-500 hover:text-red-700 font-medium text-sm border border-red-200 px-2 py-1 rounded bg-white transition-colors"
                          >
                            ❌ Delete Block
                          </button>
                        )}
                      </div>

                      <ReactQuill
                        placeholder="Write something..."
                        value={block.paragraphe}
                        onChange={(value) =>
                          setFieldValue(
                            `contentBlocks[${index}].paragraphe`,
                            value
                          )
                        }
                        modules={modules}
                        formats={formats}
                        theme="snow"
                        className="custom-quill"
                      />

                      <label className="flex flex-col items-center my-4">
                        <span className=" flex items-center justify-center font-bold gap-2 cursor-pointer text-[#5754E5] border border-[#5754E5] text-[14px] rounded-[12px] px-4 h-[40px] ">
                          <img src={AddImage} width={24} height={24} alt=" " />
                          Change Image
                        </span>
                        <input
                          type="file"
                          accept="image/*"

                          onChange={async (e) => {
  const file = e.target.files?.[0];

  if (!file) return;

  try {
    // Vérification de la dimension
    const validUrl = await validateImageDimensions(
      file,
      "content"
    );

    // L'image est valide
    setFieldValue(
      `contentBlocks[${index}].file`,
      file
    );

    setFieldValue(
      `contentBlocks[${index}].imagePreviewUrl`,
      validUrl
    );

    // Supprimer l'erreur pour ce block
    setContentImageErrors((prev) => ({
      ...prev,
      [index]: false,
    }));

  } catch (error) {
    // L'image est invalide
    setContentImageErrors((prev) => ({
      ...prev,
      [index]: true,
    }));

    // IMPORTANT :
    // On ne modifie PAS file
    // On ne modifie PAS imagePreviewUrl
    // Donc l'ancienne image reste affichée

    // Reset de l'input
    e.target.value = "";
  }
}}
                          // onChange={(e) => {
                          //   const file = e.target.files[0];
                          //   if (file) {
                          //     setFieldValue(
                          //       `contentBlocks[${index}].file`,
                          //       file
                          //     );
                          //     setFieldValue(
                          //       `contentBlocks[${index}].imagePreviewUrl`,
                          //       URL.createObjectURL(file)
                          //     );
                          //   }
                          // }}
                          className="hidden"
                        />
                        {contentImageErrors[index] ? (
                          <p className="text-red-500 text-[12px] mt-1">
                            The image size must not exceed {IMAGE_DIMENSIONS['content'].minLength} x {IMAGE_DIMENSIONS['content'].minHeight} pixels.
                          </p>
                        ) : block.imagePreviewUrl ? (
                          <img
                            src={block.imagePreviewUrl}
                            alt="Preview"
                            className="h-full w-[100px] object-cover rounded mt-2"
                          />
                        ) : (
                          <div className="mt-2 text-[#808091] text-[12px]">
                            No file selected
                          </div>
                        )}
                     
                      </label>
                    </div>
                  ))}
                  <button
                    type="button"
                    onClick={() =>
                      push({
                        titleContent: "",
                        paragraphe: "",
                        file: null,
                        imagePreviewUrl: "",
                      })
                    }
                    className="text-[#5754E5] flex items-center justify-center gap-4 text-[12px] bg-[#F1F1FF] w-full py-4 rounded-[6px] mt-3 self-start"                  >
                    <img src={IconAdd} alt="Add Another Content Block"/> Add Another Content Block
                  </button>
                </div>
              )}
            </FieldArray>

            {/* <ComponentInput
              label="Titre FAQ"
              placeholder="faqTitle"
              name="globalFaqTitle"
              valueInput={titleFAQ}
              onChange={(e) => setTitleFAQ(e.target.value)}
            /> */}

            <FieldArray name="faq">
              {({ push, remove }) => (
                <div className="">
                 
                  {values.faq.map((item, index) => (
                    <div
                      key={index}
                        className="mt-6  bg-[#F1F1FF] rounded-[6px]  p-4  relative"
                    >
                      <div className="flex justify-between items-center mb-2">
                        <span className="text-[16px] text-[#5754E5] font-medium">
                          FAQ Item {index + 1}
                        </span>
                        {values.faq.length > 1 && (
                          <button
                            type="button"
                            onClick={() => remove(index)}
                            className="text-red-500 hover:text-red-700 font-medium text-sm border border-red-200 px-2 py-1 rounded bg-white transition-colors"
                          >
                            ❌ Delete FAQ
                          </button>
                        )}
                      </div>

                      <ComponentInput
                        styleInput="flex items-center border-none justify-center mb-2"
                        placeholder={`Question ${index + 1}`}
                        name={`faq[${index}].title`}
                        valueInput={item.title}
                        onChange={handleChange}
                      />
                      <ReactQuill
                        placeholder="Write something..."
                        value={item.paragraphe}
                        onChange={(value) =>
                          setFieldValue(`faq[${index}].paragraphe`, value)
                        }
                        modules={modules}
                        formats={formats}
                        theme="snow"
                        className="custom-quill"
                      />
                    </div>
                  ))}
                  <button
                    type="button"
                    onClick={() => push({ titleContent: "", paragraphe: "" })}
                    className="text-[#5754E5] flex items-center justify-center gap-4 text-[12px] bg-[#F1F1FF] w-full py-4 rounded-[6px] mt-3 self-start"                  >
                    <img src={IconAdd} alt="Add Another FAQ"/> Add Another FAQ
                  </button>
                </div>
              )}
            </FieldArray>

            <button
              type="submit"
              disabled={isSubmitting}
              className="bg-blue-600 text-white px-6 py-2.5 rounded font-semibold hover:bg-blue-700 mt-6 w-full max-w-xs mx-auto shadow-xs disabled:opacity-50"
            >
              {isSubmitting ? "Saving Changes..." : "Update Blog Post"}
            </button>
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default DetailArticle;
